export enum ReportType {
  Pdf = 1,
  Word = 2
}
